//ENVIRONMENT FOR STAGING
export const environment = {
  production: false,
  apiUrl: 'https://stagingapi.tix.do/api',
  botApiUrl: 'http://localhost:8000/api',
  uploadsUrl: 'https://stagingapi.tix.do/uploads',
  baseUrl: 'https://stagingapi.tix.do',
  vendorsUrl: 'https://stagingvendors.tix.do',
  v3ApiUrl: 'https://api.staging.v3.tix.do',
  v3WebUrl: 'https://staging.v3.tix.do',
  encryptionKey: 'wTl18UAxQn',
  orderCheckoutTimeoutInSeconds: 240, // 4 minutes
  apiCardinal: 'https://centinelapi.cardinalcommerce.com',
  // reCAPTCHA v2 (checkbox challenge). Only shown when the backend asks for a
  // step-up: low v3 score, or a BIN flagged by decline velocity. v2 keys are
  // per-domain and are NOT the same pair as the invisible v3 ones.
  recaptchaV2SiteKey: '6LePYnktAAAAAEEFjAe4LPC_kse8ONRVFh7uIMzv',
};
